var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "products" },
    [
      _c(
        "div",
        {
          staticClass:
            "products__wrapper insicht insicht--fade-in insicht--fast",
        },
        [
          _c("Loader", {
            staticClass: "products__loader",
            attrs: { show: _vm.productsLoading && !_vm.loading },
          }),
          _vm._v(" "),
          _vm.isLoggedIn && _vm.showFavorites
            ? _c("LastOrders", {
                staticClass: "products__last-orders",
                attrs: { orders: _vm.lastOrdersFiltered },
                on: { click: _vm.onLastOrderClick },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoggedIn && _vm.favoriteProducts.length && _vm.showFavorites
            ? _c("h2", {
                staticClass: "products__title",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("shoplist.favorites.title")),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.products && !_vm.productsLoading
            ? _c(
                "div",
                { staticClass: "products__grid" },
                [
                  _vm.initialized && !_vm.productsEnhanced.length
                    ? _c("div", {
                        staticClass: "products__grid-empty",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("shoplist.noProducts")),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(
                    _vm.productsEnhancedLimited,
                    function (product, index) {
                      return _c("ShoplistProduct", {
                        key: product.code,
                        attrs: {
                          product: product,
                          locked: _vm.lockedProducts[product.code],
                        },
                        on: {
                          addToCart: _vm.onAddToCart,
                          config: _vm.onConfig,
                          click: _vm.onClickProduct,
                        },
                      })
                    }
                  ),
                  _vm._v(" "),
                  _vm.showStaticInfo1
                    ? _c("ShoplistStaticDumplings", {
                        attrs: {
                          "bg-color": "purple",
                          illustration: "box",
                          title: _vm.$te("shoplist.static.1.title")
                            ? _vm.$t("shoplist.static.1.title")
                            : null,
                          text: _vm.$te("shoplist.static.1.text")
                            ? _vm.$t("shoplist.static.1.text")
                            : null,
                          "link-text": _vm.$te("shoplist.static.1.buttonText")
                            ? _vm.$t("shoplist.static.1.buttonText")
                            : null,
                          "link-url": _vm.$te("shoplist.static.1.buttonUrl")
                            ? _vm.$t("shoplist.static.1.buttonUrl")
                            : null,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showStaticInfo2
                    ? _c("ShoplistStaticDumplings", {
                        attrs: {
                          "bg-color": "yellow",
                          illustration: "steaming-bamboo",
                          title: _vm.$te("shoplist.static.2.title")
                            ? _vm.$t("shoplist.static.2.title")
                            : null,
                          text: _vm.$te("shoplist.static.2.text")
                            ? _vm.$t("shoplist.static.2.text")
                            : null,
                          "link-text": _vm.$te("shoplist.static.2.buttonText")
                            ? _vm.$t("shoplist.static.2.buttonText")
                            : null,
                          "link-url": _vm.$te("shoplist.static.2.buttonUrl")
                            ? _vm.$t("shoplist.static.2.buttonUrl")
                            : null,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showStaticInfo3
                    ? _c("ShoplistStaticDumplings", {
                        attrs: {
                          "bg-color": "green",
                          illustration: "chopsticks",
                          title: _vm.$te("shoplist.static.3.title")
                            ? _vm.$t("shoplist.static.3.title")
                            : null,
                          text: _vm.$te("shoplist.static.3.text")
                            ? _vm.$t("shoplist.static.3.text")
                            : null,
                          "link-text": _vm.$te("shoplist.static.3.buttonText")
                            ? _vm.$t("shoplist.static.3.buttonText")
                            : null,
                          "link-url": _vm.$te("shoplist.static.3.buttonUrl")
                            ? _vm.$t("shoplist.static.3.buttonUrl")
                            : null,
                        },
                      })
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("MobileStickyCart"),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modal",
          attrs: {
            "overlay-type": "product-detail",
            "no-close": "",
            "no-padding": "",
            "full-screen": "",
          },
        },
        [
          _vm.modalProduct
            ? _c("OverlayProduct", {
                attrs: {
                  product: _vm.modalProduct,
                  locked: _vm.lockedProducts[_vm.modalProduct.code],
                },
                on: {
                  close: _vm.onModalProductClose,
                  addToCart: _vm.onAddToCart,
                  config: _vm.onConfig,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("OverlayError"),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_CHILDPRODUCTS")
        ? _c("OverlayChildProducts", {
            ref: "childproductsOverlay",
            on: { edit: _vm.onChildProductsEdit, add: _vm.onChildProductsAdd },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }